import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import AppRoutes from "./AppRoutes";

const ApplicationRoutes = () => {
  const router = createBrowserRouter(createRoutesFromElements(AppRoutes()));

  return <RouterProvider router={router} />;
};

export default ApplicationRoutes;

